import { getCookie, setCookie, removeCookie } from '~/plugins/xl-cookie'
export const state = () => ({
  userInfo: {
    userid: '',
    sessionid: '',
    nickname: '',
    account: '',
    avatar: 'https://xfile2.a.88cdn.com/file/k/avatar/default',
    is_auth: -1, // 0-认证成功 1-认证中 2-认证失败 -1-未认证 3-未成年
    id_pub: '', // 身份证
    name_pub: '', // 真名
    phone_pub: '', // 手机号
    vip_level: '', // VIP等级
    vip_type: '' // 0.非会员，1.白金会员，2.超级会员
  },
  cookie: '',
  userAgent: '',
  isWaitLogout: false,
  userLevel: { exp: 0, level: 0 }
})

export const getters = {
  isLogin: (state) => !!(state.userInfo.userid && state.userInfo.sessionid),
  authStatus: (state) => {
    let status = -1
    switch (state.userInfo.is_auth) {
      case 0:
      case 3:
        status = 0
        break
      case -1:
      case 2:
        status = -1
        break
      case 1:
        status = 1
        break
    }
    return status
  }
}

export const mutations = {
  setCookie(state, cookie) {
    state.cookie = cookie
  },
  setUserAgent(state, ua) {
    state.userAgent = ua
  },
  setUserInfo(state, obj) {
    state.userInfo = {
      ...state.userInfo,
      ...obj
    }
  },
  setUserLevel(state, level) {
    state.userLevel = level
  },
  logout(state) {
    if (process.client) {
      xlQuickLogin.logout()
      state.isWaitLogout = true
      state.userInfo.sessionid = ''
    }
  },
  clearLogin(state) {
    // 防止多次刷新
    if (process.client && state.userInfo.sessionid) {
      // xlQuickLogin.logout()
      removeCookie('sessionid')
      parent.postMessage(
        {
          type: 'xw-game-website',
          action: 'is-logout'
        },
        '*'
      )
      location.reload()
    }
    state.userInfo.sessionid = ''
  }
}

export const actions = {
  nuxtServerInit({ commit }, { req }) {
    const cookie = req.headers.cookie || ''
    const userAgent = this.$sget(req, 'headers', 'user-agent') || ''
    commit('setCookie', cookie)
    commit('setUserInfo', {
      userid: getCookie('userid', cookie),
      sessionid: getCookie('sessionid', cookie)
    })
    commit('setUserAgent', userAgent)
  },
  getUserInfo({ commit, getters, state, dispatch }, refresh = true) {
    if (!getters.isLogin) {
      return Promise.reject(new Error('need login'))
    }
    if (!refresh) {
      return state.userInfo
    }
    dispatch('getUserLevel')
    return this.$request('userInfo').then((res) => {
      commit('setUserInfo', res)
      setCookie('vip_type', res.vip_type)
      return res
    })
  },
  getUserLevel({ commit }) {
    this.$request('queryUserLevel').then((data = {}) => {
      commit('setUserLevel', data)
    })
  }
}
